import React, { useState } from 'react';
import { View } from 'react-native';

import i18n from 'i18n-js';

import TablerWrapper from '@components/auntification/tablerWrapper';
import { AUTH_OFFSET_ENTER_NAME } from '@components/auntification/tablerWrapper/constants';
import Button from '@components/button/index';
import Input from '@components/input/index';
import Logo from '@components/logo/index';

import { scale } from '@components/frame';
import { navigateTo } from '@helpers';

import ColorsWrapper from '@styles/colors';
import useStatusBar from '@components/common/useStatusBar';

const EnterName = (props) => {
  const { C, route } = props;

  const data = route?.params?.data;
  const scenario = route?.params?.scenario;

  const [formData, setFormaData] = useState({
    firstName: '',
    lastName: '',
  });

  const updateData = (value, name) => {
    setFormaData({
      ...formData,
      [name]: value,
    });
  };

  useStatusBar({ C });

  const submit = async () => {
    switch (scenario) {
      case 'invitePassword': {
        navigateTo('CreatePassword', { data: { ...data, ...formData }, scenario: 'inviteConfirmCode' });
        return;
      }
    }
  };

  return (
    <TablerWrapper offset={AUTH_OFFSET_ENTER_NAME} keyboardAvoid>
      <Logo {...{ isBack: true, title: i18n.t('Please enter your name') }} />
      <View
        style={{
          width: '90%',
          justifyContent: 'space-between',
          height: scale(242),
          marginTop: scale(10),
          alignItems: 'center',
        }}
      >
        <Input placeholder={i18n.t('First name')} onChangeText={(t) => updateData(t, 'firstName')} value={formData.firstName} />
        <Input placeholder={i18n.t('Last name')} onChangeText={(t) => updateData(t, 'lastName')} value={formData.lastName} />
        <Button
          {...{
            name: i18n.t('Done'),
            disabled: !formData.firstName || !formData.lastName,
            onPress: submit,
          }}
        />
      </View>
    </TablerWrapper>
  );
};

export default ColorsWrapper(EnterName);
